<main id="main-content" tabindex="-1">
  <div class="max-h-fit py-10">
    <div class="grid grid-cols-2">
      <div class="col-span-2 lg:col-span-1 items-center pb-4">
        <prism-title title="Reports" additionalClasses="text-3xl md:pl-20"></prism-title>
      </div>
    </div>
    <div class="grid grid-cols-2">
      <div class="col-span-2 xl:lg:col-span-1">
        <prism-report-card [isDistrict]="true" 
                           [graph]="graphType.line" 
                           [reportCardData]="districtCardData"
                           [isLoading]="isDistrictLoading">
        </prism-report-card>
      </div>
      <div class="col-span-2 xl:lg:col-span-1">
        <prism-report-card
                            [graph]="graphType.doughnut"
                            [reportCardData]="completionsCardData"
                            [schoolYearId]="schoolYearId?.value"
                            [isLoading]="isCompletionsLoading">
        </prism-report-card>
      </div>
      <!-- <div class="col-span-3 xl:lg:col-span-1">
        <prism-report-card [graph]="graphType.doughnut"
                           [reportCardData]="usersCardData">
        </prism-report-card>
      </div> -->
    </div>
    <prism-report-course-view [schoolYearId]="schoolYearId?.value"></prism-report-course-view>
  </div>
</main>
